/**
 * @file: 本地存储封装
 * @author: xiaolong.huang@dmall.com
 */

import Dexie from 'dexie';
import DexieMock from './DexieMock';

let db: any = null;

function __initDB__(tableMap: FreeObjMap): void {
    if (typeof isMochaSys !== 'undefined') {
        // 用于单元测试模拟
        db = new DexieMock('shelvesbuildDB');
    }
    else {
        db = new Dexie('shelvesbuildDB');
    }

    db.version(7).stores(tableMap);
}

function __clearDB__(): void {
    if (typeof isMochaSys !== 'undefined') {
        // 用于单元测试模拟
        DexieMock.delete('shelvesbuildDB');
    }
    else {
        Dexie.delete('shelvesbuildDB');
    }
    db = null;
}

function __get__(tableName: string, query: FreeObjMap): any {
    return db[tableName]
        .where(query)
        .toArray();
}

function __getAll__(tableName: string): any {
    return db[tableName].offset(0).toArray();
}

function __add__(tableName: string, data: FreeObjMap): any {
    return db[tableName].put(data);
}

function __addGroup__(tableName: string, dataList: Array<FreeObjMap>): any {
    return db[tableName].bulkPut(dataList);
}

function __clearTable__(tableName: string): any {
    return db && db[tableName].clear();
}

function __count__(tableName: string): any {
    return db[tableName].count();
}

function __modify__(params: FindAndModifyParams): any {
    let query: FreeObjMap = {};

    query[params.query.key] = params.query.value;
    return db[params.tableName]
        .where(query)
        .modify(params.updateData);
}

function __del__(tableName: string, query: FreeObjMap): any {
    return db[tableName].where(query).delete();
}

export {
    __initDB__,
    __clearDB__,
    __get__,
    __add__,
    __clearTable__,
    __count__,
    __modify__,
    __addGroup__,
    __del__,
    __getAll__
};
